module.exports = __webpack_public_path__ + "media/images/icons/da_svolgere_allenamento-9de51d38aaef48dce85b5ca21f99acfa.svg";